import SidebarLayout from 'components/SidebarLayout'
import ErrorView from 'views/ErrorView'

function ErrorPage() {
  return <SidebarLayout>{<ErrorView />}</SidebarLayout>
}

export default ErrorPage
